export const DEVICE_TYPES = [
    'Biurotechnika MAGNAT',
    'Elzab Sigma',
    'Elzab T10',
    'Insoft PC-Market',
    'Kucharscy KC-Firma',
    'Netis HiperMarket',
    'Novitus Next',
    'Symplex Small Business',
    'Tema Komputer POS',
    'IPH POS'
]